import {
  TRANSACTION_EP_SORTBY_CREATEDAT,
  TRANSACTION_DESC_ORDER,
  GROUPING_TRANSACTION,
} from '@/components/Settings/transaction-naming/settings.transaction.constants';
import i18n from '@/plugins/i18n';

export const transactionInit = {
  configType: '',
  isFormOpen: false,
  applicationTableList: [],
  endpointTableList: [],
  epExcludeTableList: [],
  reloadApplTable: false,
  reloadEpTable: false,
  reloadEpExTable: false,
  currentEpTransaction: GROUPING_TRANSACTION,
  epTableSort: {
    sortBy: TRANSACTION_EP_SORTBY_CREATEDAT,
    order: TRANSACTION_DESC_ORDER,
  },
  epExTableSort: {
    sortBy: TRANSACTION_EP_SORTBY_CREATEDAT,
    order: TRANSACTION_DESC_ORDER,
  },
};

export const ROLES = Object.freeze({
  USER: {
    title: i18n.global.t('setting.userRoleTerm'),
    color: '#2AC72A',
    description: i18n.global.t('setting.roRoleDescription'),
    permissions: i18n.global.t('setting.roPlatformAccess'),
  },
  TEAM_ADMIN: {
    title: i18n.global.t('setting.teamAdminRoleTerm'),
    color: '#F59600',
    description: i18n.global.t('setting.adminRoleDescription'),
    permissions: i18n.global.t('setting.platformAdminAcess'),
  },
  BI_ADMIN: {
    title: i18n.global.t('setting.billingAdminRole'),
    color: '#ecf238', //todo- change color
  },
});

export const TRACE = 'trace';
